import chroma from 'chroma-js';
import forEach from 'lodash/forEach';
import reduce from 'lodash/reduce';

type BaseColors = {
  [key: string]: string;
};

type GroupedColors = {
  baseColor: string;
  colors: string[];
}[];

const baseColors: BaseColors = {
  White: '#ffffff',
  Black: '#000000',
  Transparent: '#00000000',
  // Multicolor: '#ff00ff',
  // LightRed: '#ff6666',
  DarkRed: '#990000',
  LightGreen: '#66ff66',
  DarkGreen: '#006600',
  LightBlue: '#6666ff',
  DarkBlue: '#000099',
  LightYellow: '#ffff66',
  DarkYellow: '#999900',
  LightBrown: '#c19a6b',
  DarkBrown: '#654321',
  LightOrange: '#ffcc66',
  DarkOrange: '#cc6600',
  LightPurple: '#cc66ff',
  DarkPurple: '#660099'
};

const getClosestBaseColor = (color: string): string => {
  let minDistance = Infinity;
  let closestColor = 'Unknown';

  forEach(baseColors, (baseHex) => {
    const distance = chroma.deltaE(color, baseHex);
    if (distance < minDistance) {
      minDistance = distance;
      closestColor = baseHex;
    }
  });

  return closestColor;
};

function groupByBaseColors(colors: string[]): GroupedColors {
  if (!colors || colors.length === 0) {
    return [];
  }

  return reduce(
    colors,
    (acc: GroupedColors, color: string) => {
      const baseColor = getClosestBaseColor(color);
      const existingGroup = acc.find((group) => group.baseColor === baseColor);

      if (existingGroup) {
        existingGroup.colors.push(color);
      } else {
        acc.push({ baseColor, colors: [color] });
      }

      return acc;
    },
    []
  );
}

export default groupByBaseColors;
